<footer class="bg-light p-3 text-center">
  <!--<div class="logo"></div>-->

  <ul class="list-inline mb-0">
    <li class="list-inline-item">
      © Tin Arm Engineering Ltd. 2026
    </li>

    <li class="list-inline-item footer-link">
      <a (click)="openDialog()">Cookies</a>
    </li>

    <li class="list-inline-item footer-build">
      {{ build }}
    </li>
  </ul>
</footer>